module.exports = __webpack_public_path__ + "static/media/user-slash.754ed3ba.svg";